// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setPatientEventsReport,
  setPatientEventsReportLoading
} from 'src/store/modules/reports/patientEvents'

const initialState = {
  patientEventsReport: [],
  patientEventsReportLoading: false
}

export default handleActions(
  {
    [setPatientEventsReport](state, { payload: patientEventsReport }) {
      return {
        ...state,
        patientEventsReport
      }
    },
    [setPatientEventsReportLoading](
      state,
      { payload: patientEventsReportLoading }
    ) {
      return {
        ...state,
        patientEventsReportLoading
      }
    }
  },
  initialState
)
